import TargetsviewTable from '@components/targetsview-table'
import {Card} from 'antd'
import {Params, useFetchGet} from 'helpers/api'
import {paginationDefaults} from 'helpers/style'
import {useEffect, useState} from 'react'

export const TargetsviewTableCard = ({query, width, handleTargetClick, parentLevel}) => {
  const [meta, setMeta] = useState()
  const [data, setData] = useState()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(100)

  const fetchTargetsview = useFetchGet('targetsview')

  const getTargetsview = () => {
    const params = Params(query)
    fetchTargetsview(params, response => {
      setMeta(response.meta)
      setData(response.targetsview)
    })
  }

  useEffect(() => {
    if (query?.t_id || query?.s_id || query?.g_id) getTargetsview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  if (!data) return <></>

  return (
    <Card className={`w-${width}`}>
      <TargetsviewTable
        targetsview={data}
        pagination={paginationDefaults(meta.total, limit, setLimit, page, setPage)}
        handleTargetClick={handleTargetClick}
        parentLevel={parentLevel}
      />
    </Card>
  )
}
